import React from 'react';
import { X, Check } from 'lucide-react';
export function PainSolutionSection() {
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-97">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-98">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-text-main" data-id="element-99">
          Este sistema es para vos si...
        </h2>

        <div className="space-y-3 bg-background rounded-xl p-4 md:p-6 shadow-sm border border-gray-100" data-id="element-100">
          <ul className="space-y-3" data-id="element-101">
            {[{
            text: <>
                    <strong data-id="element-102">Siempre volvés al mismo lugar</strong> sin importar
                    cuánto lo intentés — y ya no sabés por qué
                  </>
          }, {
            text: <>
                    <strong data-id="element-103">No podés controlar cómo reaccionás</strong> y
                    después te sentís culpable por eso
                  </>
          }, {
            text: <>
                    Gastaste tiempo y plata en cursos y terapias que{' '}
                    <strong data-id="element-104">no te dieron herramientas reales</strong>
                  </>
          }, {
            text: <>
                    Sentís que <strong data-id="element-105">algo no está bien en vos</strong> pero no
                    sabés qué es exactamente
                  </>
          }].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-106">
                <div className="flex-shrink-0 mt-0.5 bg-pain/10 p-0.5 rounded-full" data-id="element-107">
                  <X className="w-4 h-4 text-pain" strokeWidth={3} data-id="element-108" />
                </div>
                <p className="text-sm md:text-base text-text-main leading-snug" data-id="element-109">
                  {item.text}
                </p>
              </li>)}
          </ul>

          <div className="h-px w-full bg-gray-200" data-id="element-110"></div>

          <div className="flex items-start gap-2" data-id="element-111">
            <div className="flex-shrink-0 mt-0.5 bg-solution/10 p-0.5 rounded-full" data-id="element-112">
              <Check className="w-4 h-4 text-solution" strokeWidth={3} data-id="element-113" />
            </div>
            <p className="text-base md:text-lg font-bold text-text-main leading-snug" data-id="element-114">
              Estás lista para entenderte de verdad, romper los ciclos y empezar
              a elegir diferente
            </p>
          </div>
        </div>

        <a href="https://tulibrodigital.lat/products/patrones-emocionales" onClick={() => {
        const w = window as any;
        w.fbq && w.fbq('track', 'AddToCart');
      }} className="block w-full text-center bg-accent text-white font-bold text-base py-3 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-115">
          QUIERO EMPEZAR AHORA →
        </a>
      </div>
    </section>;
}